<template>
  <!-- git 仓库初始化配置 -->
  <div>
    <!-- 头部 -->
    <div class="header">
      <div class="header-width">
        <div class="header-left">
          <p>
            <span class="hy">欢迎进入知会教育！</span>
            <img src="../assets/img/phone.png" alt />  全国统一热线：{{phone}}
          </p>
        </div>
        <div class="header-right">
          <p v-if="name" @click="gomine">
            您好
            <span v-html="name"></span>
            <img src="../assets/img/d.png" alt />
          </p>
          <p v-else @click="showpopup">登录/注册</p>
          <div class="pop" v-show="pop">
            <img src="../assets/img/xiaot.png" alt />
            <div class="cont">
              <p @click="goCenter">个人中心</p>
              <p @click="gonews">我的消息</p>
              <p @click="Logout">退出登录</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <div class="header-nav">
      <div class="nav-width">
        <router-link to="/" class="logo">
          <img style="width:286px;height:76px;" :src="logo" alt />
          <!-- <img src="../assets/img/wenz.png" alt /> -->
        </router-link>
        <div class="nav">
          <ul>
            <router-link to="/">
              <li :class="type=='1'?'active':''">
                首页
                <!-- <br />
                <span :class="type=='1'?'active':''">HOME</span> -->
              </li>
            </router-link>
            <router-link to="/reading">
              <li :class="type=='3'?'active':''">
                家长资讯
                <!-- <br />
                <span :class="type=='3'?'active':''">read</span> -->
              </li>
            </router-link>
            <router-link to="/topic">
              <li :class="type=='4'?'active':''">
                师资力量
                <!-- <br />
                <span :class="type=='4'?'active':''">Topic reading</span> -->
              </li>
            </router-link>
            <router-link to="/course">
              <li :class="type=='2'?'active':''">
                云端课堂
                <!-- <br />
                <span :class="type=='2'?'active':''">course</span> -->
              </li>
            </router-link>
            <router-link to="/evaluation1">
              <li :class="type=='5'?'active':''">
                心理测评
                <!-- <br />
                <span :class="type=='5'?'active':''">Evaluation</span> -->
              </li>
            </router-link>
            <router-link :to="{path:'/advisory',query: {id: 0}}">
              <li :class="type=='6'?'active':''">
                家庭指导
                <!-- <br />
                <span :class="type=='6'?'active':''">advisory</span> -->
              </li>
            </router-link>
            <!-- <a :href="href">
              <li :class="type=='7'?'active':''">
                体验中心
                <br />
                <span :class="type=='7'?'active':''">LIVE</span>
              </li>
            </a> -->
            <router-link to="/contact">
              <li :class="type=='8'?'active':''">
                联系我们
                <!-- <br />
                <span :class="type=='8'?'active':''">contact</span> -->
              </li>
            </router-link>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <Login v-show="popup==1"></Login>
  </div>
</template>

<script>
import Login from "../components/popup/login";
export default {
  inject: ["reload"],
  name: "header",
  data() {
    return {
      popup: "",
      name: "",
      type: "",
      pop: false,
      href: "",
      logo:"",
      phone:""
    };
  },
  created() {

  },
  components: {
    Login
  },
  methods: {
    // 在线课堂
    async link_data() {
      await this.$service.home
        .link_data({type:"2"})
        .then(res => {
          console.log(res.data.content)
          if (res.data.code == 200) {
            this.href=res.data.content;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
     async about() {
      await this.$service.home
        .about({})
        .then(res => {
          console.log(res.data.content)
          if (res.data.code == 200) {
            this.logo=res.data.content.pclogo_image;
            this.phone=res.data.content.phone;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //打开注册
    showpopup() {
      this.popup = 1;
    },
    gomine() {
      this.pop = !this.pop;
    },
    goCenter() {
      this.$router.push({ path: "/mine" });
      // 页面无感刷新
      this.reload();
    },
    gonews() {
      this.$router.push({ path: "/mine/news" });
      // 页面无感刷新
      this.reload();
    },
    Logout() {
      sessionStorage.clear();
      var name = this.$route.name;
      if (name == "index") {
        // 页面无感刷新
        this.reload();
      } else {
        this.$router.push({ path: "/" });
      }
    },
    urlFun() {
      const self = this;
      if (self.$route.name == "index") {
        self.type = "1";
      } else if (
        self.$route.name == "course" ||
        self.$route.name == "more" ||
        self.$route.name == "course_system" ||
        self.$route.name == "course_system1" ||
        self.$route.name == "details" ||
        self.$route.name == "pay"
      ) {
        self.type = "2";
      } else if (
        self.$route.name == "reading" ||
        self.$route.name == "read_details"
      ) {
        self.type = "3";
      } else if (
        self.$route.name == "topic" ||
        self.$route.name == "topic_details"
      ) {
        self.type = "4";
      } else if (
        self.$route.name == "evaluation1" ||
        self.$route.name == "evalu_more" ||
        self.$route.name == "evalu_details" ||
        self.$route.name == "evalu_ceping" ||
        self.$route.name == "evalu_success" ||
        self.$route.name == "evalu_result" ||
        self.$route.name == "cp_pay"
      ) {
        self.type = "5";
      } else if (
        self.$route.name == "advisory" ||
        self.$route.name == "advi_details" ||
        self.$route.name == "zx_pay"
      ) {
        self.type = "6";
      } else if (self.$route.name == "live") {
        self.type = "7";
      } else if (self.$route.name == "contact") {
        self.type = "8";
      } else {
        self.type = "";
      }
    }
  },
  watch: {
    $route(to, from) {
      this.urlFun();
    }
  },
  mounted() {
    this.urlFun();
    this.about();
    this.link_data();
    var data = sessionStorage.getItem("data");
    if (JSON.parse(sessionStorage.getItem("udata"))) {
      this.name = JSON.parse(sessionStorage.getItem("udata")).name;
    } else {
      if (data) {
        var data1 = JSON.parse(data);
        this.name = data1.name;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
}
.header {
  height: 36px;
  background: rgba(23, 117, 239, 1);
}
.header .header-width {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.header p span.hy {
  margin-right: 20px;
}
.header .header-left {
  width: 800px;
}
.header .header-right {
  text-align: right;
}
.header .header-left,
.header .header-right {
  font-size: 16px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 6px;
  position: relative;
  z-index: 999;
  /* border: 1px solid red; */
}
.header .header-right .pop {
  position: relative;
  width: 145px;
  /* border: 1px solid red; */
}
.header .header-right .pop .cont {
  position: absolute;
  top: 34px;
  left: 59px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  /* border: 1px solid red; */
}
.header-nav {
  height: 86px;
  background: rgba(255, 255, 255, 1);
}
.header-nav .nav-width {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.header-nav .logo {
  height: 86px;
  display: flex;
  align-items: center;
}
.header-nav .nav {
  width: 848px;
  display: flex;
  align-items: center;
}
.header-nav .nav ul {
  /* margin-top: 24px; */
  width: 798px;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  /* border: 1px solid red; */
}
.header-nav .nav .active {
  color: #1775ef;
}
.header-nav .nav li {
  width: 100px;
  height: 20px;
  font-size: 15px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  text-align: right;
}
.header-nav .nav li:hover{
    color: #1775ef;
}
.header-nav .nav li span {
  font-size: 9px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 13px;
  display: block;
  width: 92px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue